import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c95fe4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "idx" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "check-detail" }
const _hoisted_4 = {
  key: 0,
  class: "add-detail-box"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 1,
  class: "detail-merge"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_uf_place = _resolveComponent("uf-place")!
  const _component_uf_more_info = _resolveComponent("uf-more-info")!
  const _component_sub_form_item_group = _resolveComponent("sub-form-item-group", true)!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_uf_nvq = _resolveComponent("uf-nvq")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
    return (_openBlock(), _createElementBlock(_Fragment, {
      key: item.id
    }, [
      (item.type === 'check_place')
        ? (_openBlock(), _createBlock(_component_uf_place, {
            key: 0,
            options: item,
            defalut: _ctx.formData[item.id],
            onConfirm: ($event: any) => (_ctx.setFormDataValue($event, item.id))
          }, null, 8, ["options", "defalut", "onConfirm"]))
        : (item.type === 'check_company')
          ? (_openBlock(), _createBlock(_component_uf_more_info, {
              key: 1,
              options: item,
              list: item.lists,
              id: item.id,
              "raw-type": "company_name",
              onConfirm: ($event: any) => (_ctx.setFormDataValue($event, item.id))
            }, null, 8, ["options", "list", "id", "onConfirm"]))
          : (item.type === 'check_userinfo')
            ? (_openBlock(), _createBlock(_component_uf_more_info, {
                key: 2,
                options: item,
                list: item.lists,
                id: item.id,
                "raw-type": "name",
                onConfirm: ($event: any) => (_ctx.setFormDataValue($event, item.id))
              }, null, 8, ["options", "list", "id", "onConfirm"]))
            : (item.type === 'check_detail' && item.lists)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.lists, (list, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: list[0].shortId
                    }, [
                      _createElementVNode("div", {
                        class: "uf-sub-form-item-title",
                        style: _normalizeStyle({ color: item.power == 1 ? '#c8c9cc' : '#2d333e' })
                      }, [
                        _createElementVNode("div", _hoisted_1, _toDisplayString(item.title) + _toDisplayString(item.lists.length > 1 ? index + 1 : ""), 1),
                        (index > 0 && item.power != 1)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "delete",
                              onClick: ($event: any) => (_ctx.removeDetail(item.lists, index))
                            }, " 删除 ", 8, _hoisted_2))
                          : _createCommentVNode("", true)
                      ], 4),
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_sub_form_item_group, {
                          list: list,
                          id: item.id,
                          ref_for: true,
                          ref: _ctx.setItemRef
                        }, null, 8, ["list", "id"])
                      ])
                    ], 64))
                  }), 128)),
                  (item.power != 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("div", {
                          class: "add-detail",
                          onClick: ($event: any) => (_ctx.addDetail(item.lists))
                        }, [
                          _createVNode(_component_van_icon, {
                            name: "plus",
                            style: {"margin-right":"5px"}
                          }),
                          _createTextVNode(" " + _toDisplayString(item.action_name), 1)
                        ], 8, _hoisted_5)
                      ]))
                    : _createCommentVNode("", true),
                  (item.is_merge == 1 && item.power == 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(item.title) + "汇总：" + _toDisplayString(_ctx.getDateilMerge(item)), 1))
                    : _createCommentVNode("", true)
                ], 64))
              : (item.type === 'check_nvq')
                ? (_openBlock(), _createBlock(_component_uf_nvq, {
                    key: 4,
                    options: item,
                    default: item.nvq_arr,
                    modelValue: _ctx.formData[item.id],
                    "onUpdate:modelValue": ($event: any) => ((_ctx.formData[item.id]) = $event)
                  }, null, 8, ["options", "default", "modelValue", "onUpdate:modelValue"]))
                : (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.componentsType[item.type]), {
                    key: 5,
                    options: item,
                    modelValue: _ctx.formData[item.id],
                    "onUpdate:modelValue": ($event: any) => ((_ctx.formData[item.id]) = $event),
                    list: _ctx.list,
                    formData: _ctx.formData
                  }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "list", "formData"]))
    ], 64))
  }), 128))
}